import React, { useState, useEffect } from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/BannerSection';
import SidebarMenu from '../../components/SidebarMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/BreadcrumbNav';
import { Button } from 'react-bootstrap';
import { FaExternalLinkAlt } from 'react-icons/fa';

// Import all PDF documents directly
import RegulamentoEstagio from '../../assets/documents/regulamento_estagio.pdf';
import RegulamentoEstudantes from '../../assets/documents/regulamento_estudantes.pdf'
import RegulamentoExameAcesso from '../../assets/documents/regulamento_exame_acesso.pdf';
import CodigoConduta from '../../assets/documents/codigo_conduta.pdf';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Regulamentos' }
];

const regulamentos = [
    {
        id: 1,
        title: "REGULAMENTO N.° 5/2022",
        description: "Regulamento de Estágio dos Cursos ISP-ATLÂNTIDA",
        file: RegulamentoEstagio
    },
    {
        id: 2,
        title: "REGULAMENTO N.° 1/2022",
        description: "Regulamento dos Estudantes do ISP-ATLÂNTIDA",
        file: RegulamentoEstudantes
    },
    {
        id: 3,
        title: "REGULAMENTO N.° 1.1/2022",
        description: "Regulamento de Exame de Acesso ao Instituto Superior Politécnico Atlântida",
        file: RegulamentoExameAcesso
    },
    {
        id: 4,
        title: "CÓDIGO DE CONDUTA ACADÉMICA",
        description: "Código de Conduta Académica do Instituto Superior Politécnico Atlântida",
        file: CodigoConduta
    }
];

function Regulamentos() {
    const [ ,setIsMobile] = useState(false);

    // Detecta se é dispositivo mobile
    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
        
        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    // Função para abrir PDF no dispositivo do usuário
    const openDocument = (file) => {
        window.open(file, '_blank', 'noopener,noreferrer');
    };

    return (
        <div>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
                title="Regulamentos da instituição"
                subtitle="Normas e Regulamentações"
                description={`O Instituto Superior Politécnico Atlântida opera dentro de um quadro legal sólido, garantindo a conformidade com as normas e regulamentos educacionais vigentes.`}
                backgroundImage={require('../../assets/BannerANU_ispa.jpg')} 
                backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />

                <div className="row flex-row-reverse">
                    <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                        <SidebarMenu
                            title="Instituição"
                            items={[
                            { label: "Apresentação", href: "/instituicao" },
                            { label: "Palavras do Presidente", href: "/instituicao/palavra-do-presidente" },
                            { label: "Organigrama", href: "/instituicao/organigrama" },
                            { label: "Legalidade", href: "/instituicao/legalidade" },
                            { label: "Missão, Visão e Valores", href: "/instituicao/missao-visao-valores" },
                            { label: "Apoio Social", href: "/instituicao/apoio-social" },
                            { label: "Perguntas Frequentes", href: "/instituicao/perguntas-frequentes" },
                            { label: "Decretos", href: "/instituicao/decretos" },
                            { label: "Regulamento", href: "/instituicao/regulamentos" },
                            ]}
                        />
                        </div>
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <br />
                        <div className="details-magazine">
                            <SectionHeading title="Regulamentos" />
                            <p>
                                A nossa instituição está devidamente legalizada e reconhecida pelas autoridades competentes, cumprindo todas as exigências legais para o seu funcionamento. Atuamos com transparência e compromisso, garantindo a qualidade dos nossos serviços educacionais.
                            </p>
                            <br />
                            <div className="regulamentos-list">
                                {regulamentos.map((regulamento) => (
                                    <div key={regulamento.id} className="regulamento-item mb-4 p-3 border rounded">
                                        <div className="d-flex justify-content-between align-items-center flex-column flex-md-row">
                                            <div className="mb-2 mb-md-0 text-center text-md-start flex-grow-1">
                                                <h5 className="text-ispa mb-1">{regulamento.title}</h5>
                                                <p className="mb-0 small text-muted">{regulamento.description}</p>
                                            </div>
                                            <div className="d-flex flex-column flex-sm-row gap-2 mt-2 mt-md-0">
                                                <Button 
                                                    variant="primary" 
                                                    onClick={() => openDocument(regulamento.file)}
                                                    size="sm"
                                                >
                                                    <FaExternalLinkAlt className="me-1" /> 
                                                    Visualizar
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <br /><br />
                    </div>
                </div>
                <br /><br /><br /><br /><br />
            </main>

            <AppLayout />
        </div>
    );
}

export default Regulamentos;